(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[169],{

/***/ 37413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgAlertCircle = function SvgAlertCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7ZM12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H11.99C11.4377 17 10.99 16.5523 10.99 16C10.99 15.4477 11.4377 15 11.99 15H12Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgAlertCircle);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiA0QzE2LjQxODMgNCAyMCA3LjU4MTcyIDIwIDEyQzIwIDE2LjQxODMgMTYuNDE4MyAyMCAxMiAyMEM3LjU4MTcyIDIwIDQgMTYuNDE4MyA0IDEyQzQgNy41ODE3MiA3LjU4MTcyIDQgMTIgNFpNMjIgMTJDMjIgNi40NzcxNSAxNy41MjI4IDIgMTIgMkM2LjQ3NzE1IDIgMiA2LjQ3NzE1IDIgMTJDMiAxNy41MjI4IDYuNDc3MTUgMjIgMTIgMjJDMTcuNTIyOCAyMiAyMiAxNy41MjI4IDIyIDEyWk0xMiA3QzExLjQ0NzcgNyAxMSA3LjQ0NzcyIDExIDhWMTJDMTEgMTIuNTUyMyAxMS40NDc3IDEzIDEyIDEzQzEyLjU1MjMgMTMgMTMgMTIuNTUyMyAxMyAxMlY4QzEzIDcuNDQ3NzIgMTIuNTUyMyA3IDEyIDdaTTEyIDE1QzEyLjU1MjMgMTUgMTMgMTUuNDQ3NyAxMyAxNkMxMyAxNi41NTIzIDEyLjU1MjMgMTcgMTIgMTdIMTEuOTlDMTEuNDM3NyAxNyAxMC45OSAxNi41NTIzIDEwLjk5IDE2QzEwLjk5IDE1LjQ0NzcgMTEuNDM3NyAxNSAxMS45OSAxNUgxMloiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 97885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ customFetcher; }
/* harmony export */ });
const customFetcher = (query, variables, options)=>{
    return async ()=>{
        const NEXT_PUBLIC_API_URL = "https://platform-api.olby.com/graphql";
        const res = await fetch(NEXT_PUBLIC_API_URL || "https://platform-api.olby.com/graphql", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json",
                ...options
            },
            body: JSON.stringify({
                query,
                variables
            })
        });
        const json = await res.json();
        if (json.errors) {
            const errors = json.errors[0];
            throw errors;
        }
        return json.data;
    };
};


/***/ }),

/***/ 19767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ REQUIRED_FIELD; },
/* harmony export */   "rr": function() { return /* binding */ JUNGLE_FINANCIAL_SUPPORT_EMAIL; }
/* harmony export */ });
/* unused harmony exports COUNTRY_LIST, BREAKPOINTS, BRAZILIAN_STATES, MONTHS, PLATFORM_NAME, PLATFORM_FINANCIAL_ENTITY, THEME, JUNGLE_SUPPORT_EMAIL, JUNGLE_TALENT_SUPPORT_EMAIL, PLATFORM_WEBSITE_URL, COMPANY_WEBSITE_URL, TALENT_PREFERRED_ROLES, PRE_SIGNED_URL_REFETCH_INTERVAL, ONE_HOUR_IN_SECONDS, BI_WEEKLY, WORKABLE_STAGES, WORKABLE_STAGES_FORMATTED, WORKABLE_STAGES_FORMATTED_BACKOFFICE, WORKABLE_STAGES_OPTIONS, TALENT_PREFERRED_ROLE_OPTIONS */
/* harmony import */ var _platform_data_access__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9432);

const COUNTRY_LIST = {
    AC: {
        code: "AC",
        name: "Ascension"
    },
    AF: {
        code: "AF",
        name: "Afghanistan"
    },
    AX: {
        code: "AX",
        name: "Aland Islands"
    },
    AL: {
        code: "AL",
        name: "Albania"
    },
    DZ: {
        code: "DZ",
        name: "Algeria"
    },
    AS: {
        code: "AS",
        name: "American Samoa"
    },
    AD: {
        code: "AD",
        name: "Andorra"
    },
    AO: {
        code: "AO",
        name: "Angola"
    },
    AI: {
        code: "AI",
        name: "Anguilla"
    },
    AG: {
        code: "AG",
        name: "Antigua And Barbuda"
    },
    AR: {
        code: "AR",
        name: "Argentina"
    },
    AM: {
        code: "AM",
        name: "Armenia"
    },
    AW: {
        code: "AW",
        name: "Aruba"
    },
    AU: {
        code: "AU",
        name: "Australia"
    },
    AT: {
        code: "AT",
        name: "Austria"
    },
    AZ: {
        code: "AZ",
        name: "Azerbaijan"
    },
    BS: {
        code: "BS",
        name: "Bahamas"
    },
    BH: {
        code: "BH",
        name: "Bahrain"
    },
    BD: {
        code: "BD",
        name: "Bangladesh"
    },
    BB: {
        code: "BB",
        name: "Barbados"
    },
    BY: {
        code: "BY",
        name: "Belarus"
    },
    BE: {
        code: "BE",
        name: "Belgium"
    },
    BZ: {
        code: "BZ",
        name: "Belize"
    },
    BJ: {
        code: "BJ",
        name: "Benin"
    },
    BM: {
        code: "BM",
        name: "Bermuda"
    },
    BT: {
        code: "BT",
        name: "Bhutan"
    },
    BO: {
        code: "BO",
        name: "Bolivia"
    },
    BQ: {
        code: "BQ",
        name: "Bonaire, Saint Eustatius and Saba"
    },
    BA: {
        code: "BA",
        name: "Bosnia And Herzegovina"
    },
    BW: {
        code: "BW",
        name: "Botswana"
    },
    BR: {
        code: "BR",
        name: "Brazil"
    },
    IO: {
        code: "IO",
        name: "British Indian Ocean Territory"
    },
    BN: {
        code: "BN",
        name: "Brunei Darussalam"
    },
    BG: {
        code: "BG",
        name: "Bulgaria"
    },
    BF: {
        code: "BF",
        name: "Burkina Faso"
    },
    BI: {
        code: "BI",
        name: "Burundi"
    },
    KH: {
        code: "KH",
        name: "Cambodia"
    },
    CM: {
        code: "CM",
        name: "Cameroon"
    },
    CA: {
        code: "CA",
        name: "Canada"
    },
    CV: {
        code: "CV",
        name: "Cape Verde"
    },
    KY: {
        code: "KY",
        name: "Cayman Islands"
    },
    CF: {
        code: "CF",
        name: "Central African Republic"
    },
    TD: {
        code: "TD",
        name: "Chad"
    },
    CL: {
        code: "CL",
        name: "Chile"
    },
    CN: {
        code: "CN",
        name: "China"
    },
    CX: {
        code: "CX",
        name: "Christmas Island"
    },
    CC: {
        code: "CC",
        name: "Cocos (Keeling) Islands"
    },
    CO: {
        code: "CO",
        name: "Colombia"
    },
    KM: {
        code: "KM",
        name: "Comoros"
    },
    CG: {
        code: "CG",
        name: "Congo"
    },
    CD: {
        code: "CD",
        name: "Congo, Democratic Republic"
    },
    CK: {
        code: "CK",
        name: "Cook Islands"
    },
    CR: {
        code: "CR",
        name: "Costa Rica"
    },
    CI: {
        code: "CI",
        name: "Cote D'Ivoire"
    },
    HR: {
        code: "HR",
        name: "Croatia"
    },
    CU: {
        code: "CU",
        name: "Cuba"
    },
    CW: {
        code: "CW",
        name: "Curacao"
    },
    CY: {
        code: "CY",
        name: "Cyprus"
    },
    CZ: {
        code: "CZ",
        name: "Czech Republic"
    },
    DK: {
        code: "DK",
        name: "Denmark"
    },
    DJ: {
        code: "DJ",
        name: "Djibouti"
    },
    DM: {
        code: "DM",
        name: "Dominica"
    },
    DO: {
        code: "DO",
        name: "Dominican Republic"
    },
    EC: {
        code: "EC",
        name: "Ecuador"
    },
    EG: {
        code: "EG",
        name: "Egypt"
    },
    SV: {
        code: "SV",
        name: "El Salvador"
    },
    GQ: {
        code: "GQ",
        name: "Equatorial Guinea"
    },
    ER: {
        code: "ER",
        name: "Eritrea"
    },
    EE: {
        code: "EE",
        name: "Estonia"
    },
    ET: {
        code: "ET",
        name: "Ethiopia"
    },
    FK: {
        code: "FK",
        name: "Falkland Islands (Malvinas)"
    },
    FO: {
        code: "FO",
        name: "Faroe Islands"
    },
    FJ: {
        code: "FJ",
        name: "Fiji"
    },
    FI: {
        code: "FI",
        name: "Finland"
    },
    FR: {
        code: "FR",
        name: "France"
    },
    GF: {
        code: "GF",
        name: "French Guiana"
    },
    PF: {
        code: "PF",
        name: "French Polynesia"
    },
    GA: {
        code: "GA",
        name: "Gabon"
    },
    GM: {
        code: "GM",
        name: "Gambia"
    },
    GE: {
        code: "GE",
        name: "Georgia"
    },
    DE: {
        code: "DE",
        name: "Germany"
    },
    GH: {
        code: "GH",
        name: "Ghana"
    },
    GI: {
        code: "GI",
        name: "Gibraltar"
    },
    GR: {
        code: "GR",
        name: "Greece"
    },
    GL: {
        code: "GL",
        name: "Greenland"
    },
    GD: {
        code: "GD",
        name: "Grenada"
    },
    GP: {
        code: "GP",
        name: "Guadeloupe"
    },
    GU: {
        code: "GU",
        name: "Guam"
    },
    GT: {
        code: "GT",
        name: "Guatemala"
    },
    GG: {
        code: "GG",
        name: "Guernsey"
    },
    GN: {
        code: "GN",
        name: "Guinea"
    },
    GW: {
        code: "GW",
        name: "Guinea-Bissau"
    },
    GY: {
        code: "GY",
        name: "Guyana"
    },
    HT: {
        code: "HT",
        name: "Haiti"
    },
    VA: {
        code: "VA",
        name: "Holy See (Vatican City State)"
    },
    HN: {
        code: "HN",
        name: "Honduras"
    },
    HK: {
        code: "HK",
        name: "Hong Kong"
    },
    HU: {
        code: "HU",
        name: "Hungary"
    },
    IS: {
        code: "IS",
        name: "Iceland"
    },
    IN: {
        code: "IN",
        name: "India"
    },
    ID: {
        code: "ID",
        name: "Indonesia"
    },
    IR: {
        code: "IR",
        name: "Iran, Islamic Republic Of"
    },
    IQ: {
        code: "IQ",
        name: "Iraq"
    },
    IE: {
        code: "IE",
        name: "Ireland"
    },
    IM: {
        code: "IM",
        name: "Isle Of Man"
    },
    IL: {
        code: "IL",
        name: "Israel"
    },
    IT: {
        code: "IT",
        name: "Italy"
    },
    JM: {
        code: "JM",
        name: "Jamaica"
    },
    JP: {
        code: "JP",
        name: "Japan"
    },
    JE: {
        code: "JE",
        name: "Jersey"
    },
    JO: {
        code: "JO",
        name: "Jordan"
    },
    KZ: {
        code: "KZ",
        name: "Kazakhstan"
    },
    KE: {
        code: "KE",
        name: "Kenya"
    },
    KI: {
        code: "KI",
        name: "Kiribati"
    },
    XK: {
        code: "XK",
        name: "Kosovo"
    },
    KW: {
        code: "KW",
        name: "Kuwait"
    },
    KG: {
        code: "KG",
        name: "Kyrgyzstan"
    },
    LA: {
        code: "LA",
        name: "Lao People's Democratic Republic"
    },
    LV: {
        code: "LV",
        name: "Latvia"
    },
    LB: {
        code: "LB",
        name: "Lebanon"
    },
    LS: {
        code: "LS",
        name: "Lesotho"
    },
    LR: {
        code: "LR",
        name: "Liberia"
    },
    LY: {
        code: "LY",
        name: "Libyan Arab Jamahiriya"
    },
    LI: {
        code: "LI",
        name: "Liechtenstein"
    },
    LT: {
        code: "LT",
        name: "Lithuania"
    },
    LU: {
        code: "LU",
        name: "Luxembourg"
    },
    MO: {
        code: "MO",
        name: "Macao"
    },
    MK: {
        code: "MK",
        name: "Macedonia"
    },
    MG: {
        code: "MG",
        name: "Madagascar"
    },
    MW: {
        code: "MW",
        name: "Malawi"
    },
    MY: {
        code: "MY",
        name: "Malaysia"
    },
    MV: {
        code: "MV",
        name: "Maldives"
    },
    ML: {
        code: "ML",
        name: "Mali"
    },
    MT: {
        code: "MT",
        name: "Malta"
    },
    MH: {
        code: "MH",
        name: "Marshall Islands"
    },
    MQ: {
        code: "MQ",
        name: "Martinique"
    },
    MR: {
        code: "MR",
        name: "Mauritania"
    },
    MU: {
        code: "MU",
        name: "Mauritius"
    },
    YT: {
        code: "YT",
        name: "Mayotte"
    },
    MX: {
        code: "MX",
        name: "Mexico"
    },
    FM: {
        code: "FM",
        name: "Micronesia, Federated States Of"
    },
    MD: {
        code: "MD",
        name: "Moldova"
    },
    MC: {
        code: "MC",
        name: "Monaco"
    },
    MN: {
        code: "MN",
        name: "Mongolia"
    },
    ME: {
        code: "ME",
        name: "Montenegro"
    },
    MS: {
        code: "MS",
        name: "Montserrat"
    },
    MA: {
        code: "MA",
        name: "Morocco"
    },
    MZ: {
        code: "MZ",
        name: "Mozambique"
    },
    MM: {
        code: "MM",
        name: "Myanmar"
    },
    NA: {
        code: "NA",
        name: "Namibia"
    },
    NR: {
        code: "NR",
        name: "Nauru"
    },
    NP: {
        code: "NP",
        name: "Nepal"
    },
    NL: {
        code: "NL",
        name: "Netherlands"
    },
    NC: {
        code: "NC",
        name: "New Caledonia"
    },
    NZ: {
        code: "NZ",
        name: "New Zealand"
    },
    NI: {
        code: "NI",
        name: "Nicaragua"
    },
    NE: {
        code: "NE",
        name: "Niger"
    },
    NG: {
        code: "NG",
        name: "Nigeria"
    },
    NU: {
        code: "NU",
        name: "Niue"
    },
    NF: {
        code: "NF",
        name: "Norfolk Island"
    },
    MP: {
        code: "MP",
        name: "Northern Mariana Islands"
    },
    KP: {
        code: "KP",
        name: "North Korea"
    },
    NO: {
        code: "NO",
        name: "Norway"
    },
    OM: {
        code: "OM",
        name: "Oman"
    },
    PK: {
        code: "PK",
        name: "Pakistan"
    },
    PW: {
        code: "PW",
        name: "Palau"
    },
    PS: {
        code: "PS",
        name: "Palestinian Territory, Occupied"
    },
    PA: {
        code: "PA",
        name: "Panama"
    },
    PG: {
        code: "PG",
        name: "Papua New Guinea"
    },
    PY: {
        code: "PY",
        name: "Paraguay"
    },
    PE: {
        code: "PE",
        name: "Peru"
    },
    PH: {
        code: "PH",
        name: "Philippines"
    },
    PL: {
        code: "PL",
        name: "Poland"
    },
    PT: {
        code: "PT",
        name: "Portugal"
    },
    PR: {
        code: "PR",
        name: "Puerto Rico"
    },
    QA: {
        code: "QA",
        name: "Qatar"
    },
    RE: {
        code: "RE",
        name: "Reunion"
    },
    RO: {
        code: "RO",
        name: "Romania"
    },
    RU: {
        code: "RU",
        name: "Russian Federation"
    },
    RW: {
        code: "RW",
        name: "Rwanda"
    },
    BL: {
        code: "BL",
        name: "Saint Barthelemy"
    },
    SH: {
        code: "SH",
        name: "Saint Helena"
    },
    KN: {
        code: "KN",
        name: "Saint Kitts And Nevis"
    },
    LC: {
        code: "LC",
        name: "Saint Lucia"
    },
    MF: {
        code: "MF",
        name: "Saint Martin"
    },
    PM: {
        code: "PM",
        name: "Saint Pierre And Miquelon"
    },
    VC: {
        code: "VC",
        name: "Saint Vincent And Grenadines"
    },
    WS: {
        code: "WS",
        name: "Samoa"
    },
    SM: {
        code: "SM",
        name: "San Marino"
    },
    ST: {
        code: "ST",
        name: "Sao Tome And Principe"
    },
    SA: {
        code: "SA",
        name: "Saudi Arabia"
    },
    SN: {
        code: "SN",
        name: "Senegal"
    },
    RS: {
        code: "RS",
        name: "Serbia"
    },
    SC: {
        code: "SC",
        name: "Seychelles"
    },
    SL: {
        code: "SL",
        name: "Sierra Leone"
    },
    SG: {
        code: "SG",
        name: "Singapore"
    },
    SX: {
        code: "SX",
        name: "Sint Maarten"
    },
    SK: {
        code: "SK",
        name: "Slovakia"
    },
    SI: {
        code: "SI",
        name: "Slovenia"
    },
    SB: {
        code: "SB",
        name: "Solomon Islands"
    },
    SO: {
        code: "SO",
        name: "Somalia"
    },
    ZA: {
        code: "ZA",
        name: "South Africa"
    },
    KR: {
        code: "KR",
        name: "South Korea"
    },
    SS: {
        code: "SS",
        name: "South Sudan"
    },
    ES: {
        code: "ES",
        name: "Spain"
    },
    LK: {
        code: "LK",
        name: "Sri Lanka"
    },
    SD: {
        code: "SD",
        name: "Sudan"
    },
    SR: {
        code: "SR",
        name: "Suriname"
    },
    SJ: {
        code: "SJ",
        name: "Svalbard And Jan Mayen"
    },
    SZ: {
        code: "SZ",
        name: "Swaziland"
    },
    SE: {
        code: "SE",
        name: "Sweden"
    },
    CH: {
        code: "CH",
        name: "Switzerland"
    },
    SY: {
        code: "SY",
        name: "Syrian Arab Republic"
    },
    TW: {
        code: "TW",
        name: "Taiwan"
    },
    TJ: {
        code: "TJ",
        name: "Tajikistan"
    },
    TZ: {
        code: "TZ",
        name: "Tanzania"
    },
    TH: {
        code: "TH",
        name: "Thailand"
    },
    TL: {
        code: "TL",
        name: "Timor-Leste"
    },
    TG: {
        code: "TG",
        name: "Togo"
    },
    TK: {
        code: "TK",
        name: "Tokelau"
    },
    TO: {
        code: "TO",
        name: "Tonga"
    },
    TT: {
        code: "TT",
        name: "Trinidad And Tobago"
    },
    TA: {
        code: "TA",
        name: "Tristan da Cunha"
    },
    TN: {
        code: "TN",
        name: "Tunisia"
    },
    TR: {
        code: "TR",
        name: "Turkey"
    },
    TM: {
        code: "TM",
        name: "Turkmenistan"
    },
    TC: {
        code: "TC",
        name: "Turks And Caicos Islands"
    },
    TV: {
        code: "TV",
        name: "Tuvalu"
    },
    UG: {
        code: "UG",
        name: "Uganda"
    },
    UA: {
        code: "UA",
        name: "Ukraine"
    },
    AE: {
        code: "AE",
        name: "United Arab Emirates"
    },
    GB: {
        code: "GB",
        name: "United Kingdom"
    },
    US: {
        code: "US",
        name: "United States"
    },
    UY: {
        code: "UY",
        name: "Uruguay"
    },
    UZ: {
        code: "UZ",
        name: "Uzbekistan"
    },
    VU: {
        code: "VU",
        name: "Vanuatu"
    },
    VE: {
        code: "VE",
        name: "Venezuela"
    },
    VN: {
        code: "VN",
        name: "Viet Nam"
    },
    VG: {
        code: "VG",
        name: "Virgin Islands, British"
    },
    VI: {
        code: "VI",
        name: "Virgin Islands, U.S."
    },
    WF: {
        code: "WF",
        name: "Wallis And Futuna"
    },
    EH: {
        code: "EH",
        name: "Western Sahara"
    },
    YE: {
        code: "YE",
        name: "Yemen"
    },
    ZM: {
        code: "ZM",
        name: "Zambia"
    },
    ZW: {
        code: "ZW",
        name: "Zimbabwe"
    }
};
const REQUIRED_FIELD = "This field is required";
// TODO: Save breakpoints' values in an scss file and export them to js
const BREAKPOINTS = {
    SMALL: 703,
    MEDIUM: 1023,
    LARGE: 1439
};
const BRAZILIAN_STATES = [
    {
        value: "AC",
        label: "Acre"
    },
    {
        value: "AL",
        label: "Alagoas"
    },
    {
        value: "AP",
        label: "Amap\xe1"
    },
    {
        value: "AM",
        label: "Amazonas"
    },
    {
        value: "BA",
        label: "Bahia"
    },
    {
        value: "CE",
        label: "Cear\xe1"
    },
    {
        value: "DF",
        label: "Distrito Federal"
    },
    {
        value: "ES",
        label: "Esp\xedrito Santo"
    },
    {
        value: "GO",
        label: "Go\xedas"
    },
    {
        value: "MA",
        label: "Maranh\xe3o"
    },
    {
        value: "MT",
        label: "Mato Grosso"
    },
    {
        value: "MS",
        label: "Mato Grosso do Sul"
    },
    {
        value: "MG",
        label: "Minas Gerais"
    },
    {
        value: "PA",
        label: "Par\xe1"
    },
    {
        value: "PB",
        label: "Para\xedba"
    },
    {
        value: "PR",
        label: "Paran\xe1"
    },
    {
        value: "PE",
        label: "Pernambuco"
    },
    {
        value: "PI",
        label: "Piau\xed"
    },
    {
        value: "RJ",
        label: "Rio de Janeiro"
    },
    {
        value: "RN",
        label: "Rio Grande do Norte"
    },
    {
        value: "RS",
        label: "Rio Grande do Sul"
    },
    {
        value: "RO",
        label: "Rond\xf4nia"
    },
    {
        value: "RR",
        label: "Rora\xedma"
    },
    {
        value: "SC",
        label: "Santa Catarina"
    },
    {
        value: "SP",
        label: "S\xe3o Paulo"
    },
    {
        value: "SE",
        label: "Sergipe"
    },
    {
        value: "TO",
        label: "Tocantins"
    }
];
const MONTHS = [
    {
        value: "0",
        name: "January",
        label: "Jan"
    },
    {
        value: "1",
        name: "February",
        label: "Feb"
    },
    {
        value: "2",
        name: "March",
        label: "Mar"
    },
    {
        value: "3",
        name: "April",
        label: "Apr"
    },
    {
        value: "4",
        name: "May",
        label: "May"
    },
    {
        value: "5",
        name: "June",
        label: "Jun"
    },
    {
        value: "6",
        name: "July",
        label: "Jul"
    },
    {
        value: "7",
        name: "August",
        label: "Aug"
    },
    {
        value: "8",
        name: "September",
        label: "Sep"
    },
    {
        value: "9",
        name: "October",
        label: "Oct"
    },
    {
        value: "10",
        name: "November",
        label: "Nov"
    },
    {
        value: "11",
        name: "December",
        label: "Dec"
    }
];
const PLATFORM_NAME = "Olby";
const PLATFORM_FINANCIAL_ENTITY = {
    name: "Jungle Network, Inc.",
    email: "rodrigo@olby.com",
    cnpj: "12.345.678/0000-00",
    streetNumber: "12890",
    street: "Cross Point Dr",
    addressComplement: null,
    city: "Frisco",
    state: "TX",
    postalCode: "75033",
    country: "United States"
};
const THEME = {
    LIGHT: "light",
    DARK: "dark"
};
const JUNGLE_SUPPORT_EMAIL = "support@olby.com";
const JUNGLE_TALENT_SUPPORT_EMAIL = "talents@olby.com";
const JUNGLE_FINANCIAL_SUPPORT_EMAIL = "financial@olby.com";
const PLATFORM_WEBSITE_URL = "https://talent.olby.com";
const COMPANY_WEBSITE_URL = "https://company.olby.com";
const TALENT_PREFERRED_ROLES = {
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Backend */ .w6.Backend]: "Backend",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Frontend */ .w6.Frontend]: "Frontend",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Mobile */ .w6.Mobile]: "Mobile",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Fullstack */ .w6.Fullstack]: "Full-Stack",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.QaEngineer */ .w6.QaEngineer]: "QA Engineer",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Devops */ .w6.Devops]: "DevOps",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Design */ .w6.Design]: "Design",
    [_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Management */ .w6.Management]: "Management"
};
const PRE_SIGNED_URL_REFETCH_INTERVAL = (/* unused pure expression or super */ null && (1000 * 60 * 25)) // milliseconds * seconds * minute
;
const ONE_HOUR_IN_SECONDS = 3600;
const BI_WEEKLY = 2;
const WORKABLE_STAGES = {
    SOURCED: "Sourced",
    APPLIED: "Applied",
    INITIAL_INTERVIEW: "Initial interview",
    ENGLISH_ASSESSMENT: "English assessment",
    TECHNICAL_CHALLENGE: "Technical challenge",
    TECHNICAL_INTERVIEW: "Technical interview",
    DISQUALIFIED: "\uD83D\uDEABDISQUALIFIED\uD83D\uDEAB",
    FILL_PROFILE: "Fill profile",
    HIRED: "Hired",
    WAIT_LIST: "Waitlist"
};
const WORKABLE_STAGES_FORMATTED = {
    [WORKABLE_STAGES.SOURCED]: WORKABLE_STAGES.INITIAL_INTERVIEW,
    [WORKABLE_STAGES.APPLIED]: WORKABLE_STAGES.INITIAL_INTERVIEW,
    [WORKABLE_STAGES.ENGLISH_ASSESSMENT]: WORKABLE_STAGES.TECHNICAL_CHALLENGE,
    [WORKABLE_STAGES.INITIAL_INTERVIEW]: WORKABLE_STAGES.INITIAL_INTERVIEW,
    [WORKABLE_STAGES.TECHNICAL_CHALLENGE]: WORKABLE_STAGES.TECHNICAL_CHALLENGE,
    [WORKABLE_STAGES.TECHNICAL_INTERVIEW]: WORKABLE_STAGES.TECHNICAL_INTERVIEW
};
const WORKABLE_STAGES_FORMATTED_BACKOFFICE = {
    ...WORKABLE_STAGES_FORMATTED,
    [WORKABLE_STAGES.FILL_PROFILE]: WORKABLE_STAGES.FILL_PROFILE,
    [WORKABLE_STAGES.DISQUALIFIED]: WORKABLE_STAGES.DISQUALIFIED,
    [WORKABLE_STAGES.ENGLISH_ASSESSMENT]: WORKABLE_STAGES.ENGLISH_ASSESSMENT,
    [WORKABLE_STAGES.SOURCED]: WORKABLE_STAGES.SOURCED,
    [WORKABLE_STAGES.APPLIED]: WORKABLE_STAGES.APPLIED
};
const WORKABLE_STAGES_OPTIONS = [
    {
        label: WORKABLE_STAGES.WAIT_LIST,
        value: WORKABLE_STAGES.WAIT_LIST
    },
    {
        label: WORKABLE_STAGES.INITIAL_INTERVIEW,
        value: WORKABLE_STAGES.INITIAL_INTERVIEW
    },
    {
        label: WORKABLE_STAGES.TECHNICAL_CHALLENGE,
        value: WORKABLE_STAGES.TECHNICAL_CHALLENGE
    },
    {
        label: WORKABLE_STAGES.TECHNICAL_INTERVIEW,
        value: WORKABLE_STAGES.TECHNICAL_INTERVIEW
    },
    {
        label: WORKABLE_STAGES.FILL_PROFILE,
        value: WORKABLE_STAGES.FILL_PROFILE
    }
];
const TALENT_PREFERRED_ROLE_OPTIONS = [
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Backend */ .w6.Backend],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Backend */ .w6.Backend
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Frontend */ .w6.Frontend],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Frontend */ .w6.Frontend
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Mobile */ .w6.Mobile],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Mobile */ .w6.Mobile
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Fullstack */ .w6.Fullstack],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Fullstack */ .w6.Fullstack
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.QaEngineer */ .w6.QaEngineer],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.QaEngineer */ .w6.QaEngineer
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Devops */ .w6.Devops],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Devops */ .w6.Devops
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Design */ .w6.Design],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Design */ .w6.Design
    },
    {
        label: TALENT_PREFERRED_ROLES[_platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Management */ .w6.Management],
        value: _platform_data_access__WEBPACK_IMPORTED_MODULE_0__/* .ProfilePreferredRole.Management */ .w6.Management
    }
];


/***/ }),

/***/ 11821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QT": function() { return /* binding */ EMAIL_VALIDATION; }
});

// UNUSED EXPORTS: BIRTH_DATE_VALIDATION, CNPJ_VALIDATION, PASSWORD_RULES_KEYS, PASSWORD_RULES_LABELS, PASSWORD_RULES_VALIDATION

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parse/index.js + 22 modules
var parse = __webpack_require__(87426);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(31200);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/en-GB/index.js + 1 modules
var en_GB = __webpack_require__(66476);
;// CONCATENATED MODULE: ../../libs/utils/src/lib/regex.ts
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const HAS_LOWER_CASE_CHARACTER_REGEX = /[a-z]/;
const HAS_UPPER_CASE_CHARACTER = /[A-Z]/;
const SLACK_CHANNEL_LINK_REGEX = /^(http(s?):\/\/)?(www\.)?[a-zA-Z0-9_.-]+.slack.com\/archives\/[a-zA-Z0-9_.-]+\/?$/;
const GITHUB_LINK_REGEX = /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9_-]{1,25}$/gim;
const LINKEDIN_LINK_REGEX = /(https?:\/\/(www.)|(www.))?linkedin.com\/(mwlite\/|m\/)?in\/[a-zA-Z0-9_.-]+\/?/;
const URL_REGEX = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
const DATE_REGEX = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
const MONTH_YEAR_DATE_REGEX = /^(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
const HOURS_AND_MINUTES_REGEX = /([0-9]+(.[0-9]+)*[mMhH] *)+$/;
const BRAZILIAN_CEP_REGEX = /^\d{5}(-\d{3})?$/;
const CNPJ_REGEX = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
const REMOVE_DOUBLE_SPACE_REGEX = /\s\s+/g;
const REMOVE_TIME_REGEX = /T.*$/;

;// CONCATENATED MODULE: ../../libs/utils/src/lib/validations.ts




const EMAIL_VALIDATION = (value)=>{
    const noStartAndEndSpaces = value.trim();
    return EMAIL_REGEX.test(noStartAndEndSpaces) || "Invalid email";
};
const PASSWORD_RULES_LABELS = {
    hasMinimumTwelveCharacters: "At least 12 characters",
    hasUpperCaseCharacter: "At least 1 uppercase letter",
    hasLowerCaseCharacter: "At least 1 lowercase letter"
};
const PASSWORD_RULES_KEYS = Object.keys(PASSWORD_RULES_LABELS);
const PASSWORD_RULES_VALIDATION = {
    hasMinimumTwelveCharacters: (value)=>{
        return (value === null || value === void 0 ? void 0 : value.length) >= 12 || PASSWORD_RULES_LABELS.hasMinimumTwelveCharacters;
    },
    hasUpperCaseCharacter: (value)=>HAS_UPPER_CASE_CHARACTER.test(value) || PASSWORD_RULES_LABELS.hasUpperCaseCharacter,
    hasLowerCaseCharacter: (value)=>{
        return HAS_LOWER_CASE_CHARACTER_REGEX.test(value) && !!value || PASSWORD_RULES_LABELS.hasLowerCaseCharacter;
    }
};
const parseDate = (value)=>{
    return (0,parse/* default */.Z)(value, "P", new Date(), {
        locale: en_GB/* default */.Z
    });
};
const BIRTH_DATE_VALIDATION = {
    isValidDate: (value)=>{
        const parsedDate = parseDate(value);
        const isValidDate = (0,isValid/* default */.Z)(parsedDate);
        return DATE_REGEX.test(value) && isValidDate || "Invalid date format. Please, use DD/MM/YYYY";
    },
    isUnderAge: (value)=>{
        const parsedDate = parseDate(value);
        const years = Math.floor(Math.ceil(Math.abs(parsedDate.getTime() - new Date().getTime()) / (1000 * 3600 * 24)) / 365.25);
        return years >= 18 || "You must be 18 years or older";
    }
};
const CNPJ_VALIDATION = (value)=>{
    return validateCNPJ(value) || "Invalid CNPJ";
};


/***/ }),

/***/ 45169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newsletter_forms; }
});

// UNUSED EXPORTS: NewsletterForm

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(60431);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/custom-fetcher/index.ts
var custom_fetcher = __webpack_require__(97885);
;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/website/subscribe-to-talent-newsletter.generated.ts
/* eslint-disable */ // @ts-nocheck


const SubscribeToTalentNewsletterDocument = "\n    mutation SubscribeToTalentNewsletter($email: String!) {\n  subscribeToTalentNewsletter(email: $email)\n}\n    ";
const useSubscribeToTalentNewsletterMutation = (options)=>(0,index_production.useMutation)([
        "SubscribeToTalentNewsletter"
    ], (variables)=>(0,custom_fetcher/* customFetcher */.k)(SubscribeToTalentNewsletterDocument, variables)(), options);
useSubscribeToTalentNewsletterMutation.getKey = ()=>[
        "SubscribeToTalentNewsletter"
    ];
useSubscribeToTalentNewsletterMutation.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(SubscribeToTalentNewsletterDocument, variables, options);

// EXTERNAL MODULE: ../../libs/utils/src/lib/constants.ts
var constants = __webpack_require__(19767);
// EXTERNAL MODULE: ../../libs/utils/src/lib/validations.ts + 1 modules
var validations = __webpack_require__(11821);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/toast/toast.tsx + 2 modules
var toast = __webpack_require__(7415);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/alert-circle.svg
var alert_circle = __webpack_require__(37413);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/button/button.tsx
var button_button = __webpack_require__(79544);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/website-kit/input/index.module.scss
var index_module = __webpack_require__(80944);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/website-kit/input/index.tsx






const BUTTON_PADDING = 28;
const BUTTON_DISTANCE = 8;
const WebsiteInput = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { label , id , actionButton , error , disabled =false , className ="" , inputClassName ="" , hasError , ...restProps } = param;
    const innerRef = (0,react.useRef)(null);
    const internalButtonRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    const renderStyle = ()=>{
        const buttonElement = internalButtonRef === null || internalButtonRef === void 0 ? void 0 : internalButtonRef.current;
        const buttonWidth = (buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.offsetWidth) || 0;
        return {
            paddingRight: buttonWidth ? buttonWidth + BUTTON_PADDING + BUTTON_DISTANCE : BUTTON_PADDING
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((index_module_default())["input-wrapper"], {
            [(index_module_default())["has-error"]]: !!error
        }, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                className: (index_module_default()).label,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default())["input-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        disabled: disabled,
                        "aria-describedby": error ? "".concat(id, "helperText") : "",
                        id: id,
                        className: classnames_default()((index_module_default()).input, {
                            [(index_module_default())["input-error"]]: !!error
                        }),
                        placeholder: label,
                        ref: innerRef,
                        style: renderStyle(),
                        ...restProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                        disabled: disabled,
                        className: (index_module_default())["internal-button"],
                        type: "submit",
                        isLoading: actionButton === null || actionButton === void 0 ? void 0 : actionButton.isLoading,
                        variant: "secondary",
                        size: "large",
                        ref: internalButtonRef,
                        children: actionButton === null || actionButton === void 0 ? void 0 : actionButton.label
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                id: "".concat(id, "helperText"),
                className: (index_module_default())["helper-text"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_circle/* ReactComponent */.r, {
                        className: (index_module_default()).icon
                    }),
                    " ",
                    error
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                disabled: disabled,
                className: (index_module_default())["mobile-button"],
                type: "submit",
                isLoading: actionButton === null || actionButton === void 0 ? void 0 : actionButton.isLoading,
                variant: "secondary",
                size: "large",
                children: actionButton === null || actionButton === void 0 ? void 0 : actionButton.label
            })
        ]
    });
});
/* harmony default export */ var input = (WebsiteInput);

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/newsletter-forms/index.module.scss
var newsletter_forms_index_module = __webpack_require__(68371);
var newsletter_forms_index_module_default = /*#__PURE__*/__webpack_require__.n(newsletter_forms_index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/newsletter-forms/index.tsx







const NewsletterForm = (param)=>{
    let { className  } = param;
    var ref;
    const { register , formState: { errors  } , handleSubmit , reset  } = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit"
    });
    const { mutate , isLoading  } = useSubscribeToTalentNewsletterMutation({
        onSuccess: ()=>{
            reset();
            (0,toast/* toast */.A)({
                title: "You successfully joined our newsletter!"
            });
        }
    });
    const actionButton = {
        label: "Subscribe",
        isLoading
    };
    const onSubmit = handleSubmit((formData)=>{
        mutate(formData);
        return;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: className,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
            placeholder: "Your email",
            label: "Your email",
            id: "newsletterEmailInput",
            actionButton: actionButton,
            className: (newsletter_forms_index_module_default()).input,
            ...register("email", {
                required: constants/* REQUIRED_FIELD */.Ce,
                validate: validations/* EMAIL_VALIDATION */.QT
            }),
            error: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
        })
    });
};
/* harmony default export */ var newsletter_forms = (NewsletterForm);


/***/ }),

/***/ 68371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"newsletter-forms_input__tZ_s6","fade-in-up":"newsletter-forms_fade-in-up__YYiz2","fade-in-opacity":"newsletter-forms_fade-in-opacity__NlfP0","fade-in-up-opacity":"newsletter-forms_fade-in-up-opacity__3qH5U","fade-out-opacity":"newsletter-forms_fade-out-opacity__nLDby","fade-out-left":"newsletter-forms_fade-out-left__XMw0C"};

/***/ }),

/***/ 80944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"input_input-wrapper__GA5dd","label":"input_label__IDcHa","input-container":"input_input-container__nX6tN","input":"input_input__Z0zRh","theme--light":"input_theme--light__W81yX","theme--dark":"input_theme--dark__Ohlqg","input-error":"input_input-error__Nd7P8","internal-button":"input_internal-button__hWlRM","helper-text":"input_helper-text__x2fju","icon":"input_icon__mwlOs","mobile-button":"input_mobile-button__0Cfu8","fade-in-up":"input_fade-in-up__5KA8V","fade-in-opacity":"input_fade-in-opacity__4guMC","fade-in-up-opacity":"input_fade-in-up-opacity__BIEq2","fade-out-opacity":"input_fade-out-opacity__eD45e","fade-out-left":"input_fade-out-left__u4kgf"};

/***/ })

}]);